// extracted by mini-css-extract-plugin
export var banner = "_my-0";
export var settingRow = "_my-2";
export var titleIcon = "_my-1";